import React, { useState } from 'react';
import UserManagement from './UserManagement';
import OrganizerManagement from './OrganizerManagement';
import BillingManagement from './BillingManagement';
import Settings from './Settings';
import Statistics from './Statistics';
import Logs from './Logs';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'users' | 'organizers' | 'billing' | 'logs' | 'statistics' | 'settings'>('users');

  return (
    <div className="admin-dashboard">
      <div className="page-header">
        <h1>Administrasjon</h1>
      </div>

      <div className="tabbed-section">
        <div className="tabs">
          <button 
            className={`tab ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            👥 Brukeradministrasjon
          </button>
          <button 
            className={`tab ${activeTab === 'organizers' ? 'active' : ''}`}
            onClick={() => setActiveTab('organizers')}
          >
            🎯 Arrangøradministrasjon
          </button>
          <button 
            className={`tab ${activeTab === 'billing' ? 'active' : ''}`}
            onClick={() => setActiveTab('billing')}
          >
            💰 Fakturering
          </button>
          <button 
            className={`tab ${activeTab === 'logs' ? 'active' : ''}`}
            onClick={() => setActiveTab('logs')}
          >
            📋 Logg
          </button>
          <button 
            className={`tab ${activeTab === 'statistics' ? 'active' : ''}`}
            onClick={() => setActiveTab('statistics')}
          >
            📊 Statistikk
          </button>
          <button 
            className={`tab ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            ⚙️ Plattforminnstillinger
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'users' && <UserManagement />}
          {activeTab === 'organizers' && <OrganizerManagement />}
          {activeTab === 'billing' && <BillingManagement />}
          {activeTab === 'logs' && <Logs />}
          {activeTab === 'statistics' && <Statistics />}
          {activeTab === 'settings' && <Settings />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
